import { motion } from 'framer-motion';

export function AnimatedCar({ image, isActive }) {
  return (
    <motion.img
      key={isActive ? 'active' : 'inactive'}
      src={image}
      alt="Carro em destaque"
      className="
        absolute bottom-0 right-0
        w-[80%] max-w-[800px]
        pointer-events-none select-none
        z-20
      "
      initial={{
        x: 200,
        opacity: 0,
      }}
      animate={
        isActive
          ? { x: 0, opacity: 1 }
          : { x: 200, opacity: 0 }
      }
      transition={{
        duration: 1.5,
        delay: 0.6,
        ease: [0.22, 1, 0.36, 1],
      }}
    />
  );
}